import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import TextAreaField from '../../../../BaseModule/Components/Form/Components/TextAreaField/TextAreaField';

interface Props {
	item: Extract<
		WizardItem,
		{ type: WizardItemType.TEXT_AREA | WizardItemType.TEXT_AREA_2 }
	>;
}

const WizardTextArea: React.FC<Props> = ({ item }) => {
	return (
		<TextAreaField
			name={item.key}
			label={item.title}
			isRequired={item.settings?.required}
			isWrapped
		/>
	);
};

export default WizardTextArea;
